import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ActionWarning } from '../../services/caseWorkflowService';
import { warningText } from './projectOutcomesVocabulary';
import { ink } from '../../theme/tokens';

/**
 * Case state that contradicts the hand-off rules, said in words.
 *
 * Shown only when something fires. Without it the numbers above can quietly
 * disagree with each other — a SAR draft ready for preparation whose EDD has not
 * been signed off — and the reader has no way to tell which one is wrong.
 */
const IntegrityWarnings: React.FC<{ warnings: ActionWarning[] }> = ({ warnings }) => {
    if (!warnings.length) return null;
    return (
        <section
            aria-label="Case state to check"
            className="text-left rounded-xl border border-[#FBBF24]/40 bg-[#FBBF24]/5 px-4 py-3 space-y-2"
        >
            {warnings.map((warning) => {
                const { title, detail } = warningText(warning);
                return (
                    <div key={warning.code} className="flex items-start gap-2">
                        <WarningAmberIcon sx={{ fontSize: 16, color: ink('#FBBF24'), mt: '2px' }} aria-hidden />
                        <div className="min-w-0">
                            <div className="text-sm text-fg font-medium">{title}</div>
                            {detail && <div className="text-xs text-fg-2">{detail}</div>}
                            {warning.sample.length > 0 && (
                                <div className="text-[11px] text-fg-muted font-mono truncate">
                                    {warning.sample.join(', ')}{warning.count > warning.sample.length ? ', …' : ''}
                                </div>
                            )}
                        </div>
                    </div>
                );
            })}
        </section>
    );
};

export default IntegrityWarnings;
